export default __webpack_public_path__ + "static/media/navigator.33d26f61.png";